// Lightweight client-side preferences stored in localStorage.
// Keys are prefixed `sr_pref_` so they're easy to clear separately from auth tokens.

const PREFIX = "sr_pref_";

export const PREF_CELEBRATIONS = "celebrations"; // milestone confetti + haptics

export function getPref(key, fallback) {
  try {
    const v = localStorage.getItem(PREFIX + key);
    if (v === null) return fallback;
    if (v === "true") return true;
    if (v === "false") return false;
    return v;
  } catch {
    return fallback;
  }
}

export function setPref(key, value) {
  try {
    localStorage.setItem(PREFIX + key, String(value));
  } catch { /* ignore */ }
}

// Track which milestone ids the user has already seen unlocked.
// Returns the array of NEWLY unlocked ids (not yet seen), and atomically
// updates the seen list to include them so we never celebrate the same one twice.
const SEEN_KEY = "sr_seen_milestones";

export function getNewlyUnlockedMilestones(milestones) {
  if (!Array.isArray(milestones)) return [];
  let seen;
  try {
    seen = JSON.parse(localStorage.getItem(SEEN_KEY) || "[]");
    if (!Array.isArray(seen)) seen = [];
  } catch { seen = []; }

  const currentlyUnlocked = milestones.filter((m) => m && m.unlocked && m.id).map((m) => m.id);
  const isFirstRun = seen.length === 0;

  // First-ever load — don't pop a confetti storm for every pre-existing milestone.
  // Mark them all as seen silently and return [].
  if (isFirstRun) {
    try { localStorage.setItem(SEEN_KEY, JSON.stringify(currentlyUnlocked)); } catch { /* ignore */ }
    return [];
  }

  const newly = currentlyUnlocked.filter((id) => !seen.includes(id));
  if (newly.length > 0) {
    const merged = Array.from(new Set([...seen, ...newly]));
    try { localStorage.setItem(SEEN_KEY, JSON.stringify(merged)); } catch { /* ignore */ }
  }
  return newly;
}
